module.exports = "<p>\n  checkout works!\n</p>\n"